/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    clientReference?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    abbreviatedName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the Product interface.
 */
export function instanceOfProduct(value: object): value is Product {
    return true;
}

export function ProductFromJSON(json: any): Product {
    return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): Product {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'clientReference': json['clientReference'] == null ? undefined : json['clientReference'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'abbreviatedName': json['abbreviatedName'] == null ? undefined : json['abbreviatedName'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function ProductToJSON(value?: Product | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'clientReference': value['clientReference'],
        'fullName': value['fullName'],
        'abbreviatedName': value['abbreviatedName'],
        'isActive': value['isActive'],
    };
}

